import Apple from '../assets/apple.png'
import Google from '../assets/google-play.png'
import CategoriesHero from '../assets/categories-hero.png'
import MarketFirst from '../assets/market-first.png'
import PandS from '../assets/p-and-s.png'
import PanIndia from '../assets/pan-india.png'
import ServicesIcon from '../assets/services-icon.png'
import ServicesIcon6 from '../assets/services-icon-6.png'
import Consultation from '../assets/consultation.png'
import DietManagement from '../assets/diet-management.png'
import MentalWellness from '../assets/mental-wellness.png'
import NaturalFertility from '../assets/natural-ferility.png'
import NurseryDesign from '../assets/nursery-design.png'
import Shop from '../assets/shop.png'
import Slide1 from '../assets/slide-1.jpg'
import Slide2 from '../assets/slide-2.png'
import Slide3 from '../assets/slide-3.png'
import Slide4 from '../assets/slide-4.png'
import Slide5 from '../assets/slide-5.png'
import Slide6 from '../assets/slide-6.png'
import Slide7 from '../assets/slide-7.png'
import TopDeal1 from '../assets/top-deal-1.png'
import TopDeal2 from '../assets/top-deal-2.jpeg'
import TopDeal3 from '../assets/top-deal-3.jpg'
import TopDeal4 from '../assets/top-deal-4.jpg'
import TopDeal5 from '../assets/top-deal-5.png'
import TopDeal6 from '../assets/top-deal-6.jpg'
import FeaturedProd1 from '../assets/featured-prod-1.png'
import FeaturedProd2 from '../assets/featured-prod-2.png'
import FeaturedProd3 from '../assets/featured-prod-3.png'
import FeaturedProd4 from '../assets/featured-prod-4.png'
import FeaturedProd5 from '../assets/featured-prod-5.jpg'
import FeaturedProd6 from '../assets/featured-prod-6.jpg'
import Story1 from '../assets/story1.jpg'
import PopularCatGif from '../assets/popular-cat-gif.gif'
import PopularCat1 from '../assets/popular-cat-1.png'
import PopularCat2 from '../assets/popular-cat-2.png'
import PopularCat3 from '../assets/popular-cat-3.png'
import PopularCat4 from '../assets/popular-cat-4.png'
import PopularCat5 from '../assets/popular-cat-5.png'
import PopularCat6 from '../assets/popular-cat-6.png'
import Partner1 from '../assets/partner-1.png'
import Partner2 from '../assets/partner-2.png'
import Partner3 from '../assets/partner-3.png'
import Partner4 from '../assets/partner-4.png'
import Partner5 from '../assets/partner-5.png'
import Partner6 from '../assets/partner-6.png'
import Partner7 from '../assets/partner-7.jpeg'
import Manhood1 from '../assets/manhood-1.jpg'
import Manhood2 from '../assets/manhood-2.png'
import Manhood3 from '../assets/manhood-3.jpg'
import Manhood4 from '../assets/manhood-4.png'
import Manhood5 from '../assets/manhood-5.jpg'
import Manhood6 from '../assets/manhood-6.jpeg'
import Manhood7 from '../assets/manhood-7.jpg'
import Manhood8 from '../assets/manhood-8.png'
import Logo from '../assets/logo.png'


export default {
    Apple,
    Google,
    CategoriesHero,
    MarketFirst,
    PandS,
    PanIndia,
    ServicesIcon,
    ServicesIcon6,
    Consultation,
    DietManagement,
    MentalWellness,
    NaturalFertility,
    NurseryDesign,
    Shop,
    Slide1,
    Slide2,
    Slide3,
    Slide4,
    Slide5,
    Slide6,
    Slide7,
    TopDeal1,
    TopDeal2,
    TopDeal3,
    TopDeal4,
    TopDeal5,
    TopDeal6,
    FeaturedProd1,
    FeaturedProd2,
    FeaturedProd3,
    FeaturedProd4,
    FeaturedProd5,
    FeaturedProd6,
    Story1,
    PopularCatGif,
    PopularCat1,
    PopularCat2,
    PopularCat3,
    PopularCat4,
    PopularCat5,
    PopularCat6,
    Partner1,
    Partner2,
    Partner3,
    Partner4,
    Partner5,
    Partner6,
    Partner7,
    Manhood1,
    Manhood2,
    Manhood3,
    Manhood4,
    Manhood5,
    Manhood6,
    Manhood7,
    Manhood8,
    Logo,
}